import { codeSplit, Controller, FetchOptions } from 'bernie-core';
import { PageData } from 'bernie-http';
import { helpCenterPageIdentifier } from '../common/constant';

// "controllers" map directly to react-router routes, can additionally provide data
export class KnowledgeBaseController implements Controller {
  public pageId = helpCenterPageIdentifier;
  public path = '/helpcenter/knowledgebase';
  public routeName = 'knowledgebase';
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "knowledgebase" */ '../views/knowledge-base'));
  public exact = true;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public fetch(options: FetchOptions): Promise<any> {
    return Promise.resolve({ title: 'Knowledge Base ', pageId: this.pageId });
  }

  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({
      title: 'Knowledge Base ',
      pageId: this.pageId,
      appName: 'Knowledge Base ',
    }) as Promise<PageData>;
  }
}
